import * as React from 'react'
import { fromJSX } from 'widgets-for-react'
import { DP } from '../../../drupal/blockDefinitions'
import { dummyData, randomTitle } from '../../../utils/dummyData'
import { ModernBlock } from '../../modernBlocks.state'
import { cookieBlockClasses, CookieBlockLayout, CookieBlockLayoutInner } from './cookieBlock.layout'
import { CookieBlockProps } from './cookieBlock.state'
import { drupal } from './cookieBlock.adapters'
import { getClassNameModern } from '../../../../../../Shared/Frontend/utils/getClassNameFromStyle'

export const cookieBlock: ModernBlock<CookieBlockProps, any, any, DP.CookieBlock> = {
  kind: 'cookieBlock',
  render: (setRootState, rootState, blockIndex, blockProps, amountNested) =>
    fromJSX((updateBlock) => (
      <CookieBlockLayoutInner>
        {
          CookieBlockLayout(blockProps, rootState).run(setRootState)
        }
      </CookieBlockLayoutInner>
    )),
  adapters: {
    drupal: drupal
  },
  sampleExample: [
    {
      title: randomTitle(),
      intro: dummyData.intro,
      text: dummyData.typography,
      anchorTitle: 'cookie-sample-1',
      inviewState: false,
    }
  ],
  seoEvents: (props, blockIndex) =>
    [],
  inView: {
    showAs: 'section',
    threshold: 0.1,
    triggerOnce: true,
    inViewClassName: getClassNameModern(cookieBlockClasses, 'inview', 'inview'),
    updateState: (currentInviewState, currentBlockState) => {
      return {
        ...currentBlockState,
        inviewState: currentInviewState
      }
    }
  },
  blockClassName: getClassNameModern(cookieBlockClasses, 'block', 'mb-6')
}
